import {useEffect} from 'react'

import {useFormState} from 'react-final-form'

import {useFormDirty} from '../contexts/FormDirtyContext'

/**
 * @component FormDirtyTracker
 * @description A utility component that tracks changes in form values and updates the form's dirty state.
 * This component does not render any UI elements but serves as a connector between react-final-form's
 * form state and the FormDirtyContext. It should be placed inside a react-final-form Form component
 * and within a FormDirtyProvider to function correctly.
 **/

export const FormDirtyTracker = () => {
  const {values: currentValues} = useFormState()
  const {updateDirtyState} = useFormDirty()

  useEffect(() => {
    updateDirtyState(currentValues)
  }, [currentValues, updateDirtyState])

  return null
}
